(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/bingo-card/assets/javascripts/partials/countdown-timer.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/bingo-card/assets/javascripts/partials/countdown-timer.js');
"use strict";


const {
  useState,
  useMemo,
  useEffect
} = React;
const {
  useInterval
} = svs.components.lbUtils;
const {
  GameRoomStatus
} = svs.bingo_react.components.common.constants;
const CountdownTimer = _ref => {
  let {
    startTime,
    status
  } = _ref;
  const [timer, setTimer] = useState(null);
  const intervalId = useInterval(() => {
    const startDate = new Date(startTime);
    const duration = dateFns.intervalToDuration({
      start: new Date(),
      end: startDate
    });
    setTimer(duration);
  }, 1000, true, startTime);
  useEffect(() => {
    if ((timer === null || timer === void 0 ? void 0 : timer.minutes) === 0 && (timer === null || timer === void 0 ? void 0 : timer.seconds) === 0 || status === GameRoomStatus.STARTING) {
      clearInterval(intervalId);
      setTimer(null);
    }
  }, [timer, intervalId, status]);
  if (status === GameRoomStatus.STARTING || !timer) {
    return React.createElement("div", {
      className: "bingo-card-countdown"
    }, React.createElement("span", {
      className: "bingo-card-countdown__blinking-text"
    }, "00:00"));
  }
  return React.createElement("div", {
    className: "bingo-card-countdown"
  }, "".concat(timer.minutes.toString().padStart(2, '0'), ":").concat(timer.seconds.toString().padStart(2, '0')));
};
setGlobal('svs.bingo_react.components.bingoCard.CountdownTimer', CountdownTimer);

 })(window);